import './Loading.css';

export function Loading() {
    return <div style={{color: "#ac2b37"}} className="lds-hourglass"></div>
}